import { render, staticRenderFns } from "./FormFermentationBatch.vue?vue&type=template&id=383f06f3&scoped=true&"
import script from "./FormFermentationBatch.vue?vue&type=script&lang=js&"
export * from "./FormFermentationBatch.vue?vue&type=script&lang=js&"
import style0 from "./FormFermentationBatch.vue?vue&type=style&index=0&id=383f06f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f06f3",
  null
  
)

export default component.exports